"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _api = require("../helpers/api.js");
var _immutable = require("immutable");
var _constants = require("../constants");
var Session = /*#__PURE__*/_createClass(function Session(api, config, notifications, performance, questionBanks) {
  var _this = this;
  _classCallCheck(this, Session);
  this.sessionReset = function (key) {
    if (_this.config.browser) {
      _this.config.clearLocalStorage();
      _this.config.clearSessionStorage();
    }
    return {
      type: _constants.SESSION_RESET,
      payload: {
        key: key
      }
    };
  };
  this.sessionResetOffline = function () {
    return {
      type: _constants.SESSION_RESET_OFFLINE
    };
  };
  this.sessionFetched = function (response) {
    var fetchAssociations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var forceQuestionBankId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var isIframe = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var key = arguments.length > 4 ? arguments[4] : undefined;
    var isLTI = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    return function (dispatch, getState) {
      var _response$data$relati, _response$data$relati2;
      var userId = parseInt(response.data.id);
      var selectedQuestionBankIdChanged = false;
      var selectedQuestionBankId = 0;
      if (response.data.relationships.last_selected_question_bank.data) {
        selectedQuestionBankId = parseInt(response.data.relationships.last_selected_question_bank.data.id);
      }
      var questionBanksJSON = response.included.filter(function (record) {
        return record.type === 'question_bank';
      });
      var availableQuestionBankIds = questionBanksJSON.map(function (questionBank) {
        return parseInt(questionBank.id);
      });
      if (forceQuestionBankId && availableQuestionBankIds.includes(parseInt(forceQuestionBankId)) && selectedQuestionBankId !== parseInt(forceQuestionBankId)) {
        response.data.relationships.last_selected_question_bank = {
          data: {
            id: forceQuestionBankId
          }
        };
        selectedQuestionBankId = parseInt(forceQuestionBankId);
        selectedQuestionBankIdChanged = true;
      }
      if (forceQuestionBankId && !selectedQuestionBankIdChanged && !response.data.attributes.whitelisted_question_bank_ids.includes(forceQuestionBankId)) {
        selectedQuestionBankIdChanged = true;
      }
      if (!selectedQuestionBankId || !availableQuestionBankIds.includes(selectedQuestionBankId)) {
        response.data.relationships.last_selected_question_bank = {
          data: {
            id: '0'
          }
        };
        selectedQuestionBankId = 0;
      }
      var persistedUserId = getState().session.get('current_user_id');
      if (persistedUserId && persistedUserId !== userId) {
        dispatch(_this.sessionReset());
      }
      if (_this.config.browser && selectedQuestionBankId) dispatch(_this.questionBanks.questionBankFetchSubjects(selectedQuestionBankId, userId));
      if (fetchAssociations) {
        dispatch(_this.notifications.notificationsFetch(userId));
      }
      if (selectedQuestionBankId && availableQuestionBankIds.includes(selectedQuestionBankId)) {
        if (!selectedQuestionBankIdChanged && fetchAssociations) {
          if (isLTI) {
            dispatch(_this.performance.performanceQuizzesFetch(userId));
            dispatch(_this.performance.performanceResponsesFetch(userId));
            dispatch(_this.performance.performanceQuestionsFetch(selectedQuestionBankId, userId));
            dispatch(_this.performance.performancePeersFetch(selectedQuestionBankId, userId));
          } else {
            dispatch(_this.performance.performanceQuestionsFetch(selectedQuestionBankId, userId));
          }
        }
        if (selectedQuestionBankIdChanged) {
          dispatch(_this.questionBanks.questionBankSelect(selectedQuestionBankId, userId, fetchAssociations));
        }
      }
      var selectedOrganizationId = parseInt((_response$data$relati = response.data.relationships.last_selected_organization) === null || _response$data$relati === void 0 ? void 0 : (_response$data$relati2 = _response$data$relati.data) === null || _response$data$relati2 === void 0 ? void 0 : _response$data$relati2.id);
      var staffOrganizationIds = new _immutable.Set(response.included.filter(function (o) {
        return o.type === 'organizational_membership' && o.relationships.user.data.id === response.data.id && !o.attributes.deactivated && o.attributes.verified && ['admin', 'instructor', 'super admin'].includes(o.attributes.role);
      }).map(function (o) {
        return parseInt(o.relationships.organization.data.id);
      })).toArray();
      if (!selectedOrganizationId || staffOrganizationIds.length > 0 && !staffOrganizationIds.includes(selectedOrganizationId)) {
        selectedOrganizationId = parseInt(staffOrganizationIds[0]);
      }
      dispatch({
        type: _constants.SESSION_FETCHED,
        payload: _objectSpread({
          key: key,
          isIframe: isIframe,
          selectedOrganizationId: selectedOrganizationId
        }, response)
      });
    };
  };
  this.getSessionLogoutKey = function () {
    return 'session-logout';
  };
  this.sessionLogout = function (ev) {
    return function (dispatch, getState) {
      if (ev) ev.preventDefault();
      var key = _this.getSessionLogoutKey();
      var _getState = getState(),
        loading = _getState.loading;
      if (loading.has(key)) return loading.get(key);
      var promise = _this.api.delete('sessions/sign_out').then(function () {
        dispatch(_this.sessionReset(key));
        return true;
      });
      dispatch({
        type: _constants.SESSION_FETCHING,
        payload: {
          key: key,
          promise: promise
        }
      });
      return promise;
    };
  };
  this.getSessionLoginKey = function () {
    return 'session-login';
  };
  this.sessionLogin = function (email, password, deviceId) {
    var fetchAssociations = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    return function (dispatch, getState) {
      var key = _this.getSessionLoginKey();
      var _getState2 = getState(),
        loading = _getState2.loading;
      if (loading.has(key)) return loading.get(key);
      var promise = _this.api.post('sessions/sign_in', {
        user: {
          email: email,
          password: password,
          device_id: deviceId
        }
      }).then(function (response) {
        dispatch(_this.sessionFetched(response, fetchAssociations, null, false, key));
        return response;
      }).catch(function (error) {
        dispatch(_this.sessionReset(key));
        throw error;
      });
      dispatch({
        type: _constants.SESSION_FETCHING,
        payload: {
          key: key,
          promise: promise
        }
      });
      return promise;
    };
  };
  this.getSessionAtiLoginKey = function () {
    return 'session-ati-login';
  };
  this.sessionAtiLogin = function (email, password, deviceId) {
    var fetchAssociations = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    return function (dispatch, getState) {
      var key = _this.getSessionAtiLoginKey();
      var _getState3 = getState(),
        loading = _getState3.loading;
      if (loading.has(key)) return loading.get(key);
      var promise = _this.api.post('ati_sessions/sign_in', {
        user: {
          email: email,
          password: password,
          device_id: deviceId
        }
      }).then(function (response) {
        dispatch(_this.sessionFetched(response, fetchAssociations, null, false, key));
        return response;
      }).catch(function (error) {
        dispatch(_this.sessionReset(key));
        throw error;
      });
      dispatch({
        type: _constants.SESSION_FETCHING,
        payload: {
          key: key,
          promise: promise
        }
      });
      return promise;
    };
  };
  this.getSessionLoginLTIKey = function () {
    return 'session-login-lti';
  };
  this.sessionLoginLTI = function (userID, assignmentID) {
    var fetchAssociations = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    return function (dispatch, getState) {
      var key = _this.getSessionLoginLTIKey();
      var _getState4 = getState(),
        loading = _getState4.loading;
      if (loading.has(key)) return loading.get(key);
      var promise = _this.api.post('sessions/lti_sign_in', {
        user: {
          id: userID
        },
        assignment: {
          id: assignmentID
        }
      }).then(function (response) {
        dispatch(_this.sessionFetched(response, fetchAssociations, null, false, key, true));
        return response;
      }).catch(function (error) {
        dispatch(_this.sessionReset(key));
        throw error;
      });
      dispatch({
        type: _constants.SESSION_FETCHING,
        payload: {
          key: key,
          promise: promise
        }
      });
      return promise;
    };
  };
  this.getSessionLoginUAKey = function () {
    return 'session-login-ua';
  };
  this.sessionLoginUA = function (token, deviceId) {
    var fetchAssociations = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    return function (dispatch, getState) {
      var key = _this.getSessionLoginUAKey();
      var _getState5 = getState(),
        loading = _getState5.loading;
      if (loading.has(key)) return loading.get(key);
      var promise = _this.api.post('sessions/sign_in', {
        user: {
          ua_auth_token: token,
          device_id: deviceId
        }
      }, {
        timeout: 20000
      }).then(function (response) {
        dispatch(_this.sessionFetched(response, fetchAssociations, null, false, key, false));
        return response;
      }).catch(function (error) {
        dispatch(_this.sessionReset(key));
        throw error;
      });
      dispatch({
        type: _constants.SESSION_FETCHING,
        payload: {
          key: key,
          promise: promise
        }
      });
      return promise;
    };
  };
  this.getSessionCheckKey = function () {
    return 'session-check';
  };
  this.sessionCheck = function () {
    var fetchAssociations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var forceQuestionBankId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var isIframe = arguments.length > 2 ? arguments[2] : undefined;
    var impersonateId = arguments.length > 3 ? arguments[3] : undefined;
    return function (dispatch, getState) {
      var key = _this.getSessionCheckKey();
      var _getState6 = getState(),
        loading = _getState6.loading;
      if (loading.has(key)) {
        console.log('Loading already in progress for key:', key);
        return loading.get(key);
      }
      var promise = _this.api.get("sessions/check?is_iframe=".concat(isIframe).concat(impersonateId ? "&impersonate=".concat(impersonateId) : '')).then(function (response) {
        if (response.data) {
          dispatch(_this.sessionFetched(response, fetchAssociations, forceQuestionBankId, isIframe, key));
          return response;
        }
        dispatch(_this.sessionReset(key));
        return false;
      }).catch(function (error) {
        if (_this.config.browser) dispatch(_this.sessionReset(key));
        if (!_this.config.browser && !error.isNetworkError && !(error.response && error.response.status === 503)) {
          return false;
        }
        if (_this.config.browser && !error.isNetworkError) {
          return false;
        }
        if (error.response && error.response.status === 404) return false;
        throw error;
      });
      dispatch({
        type: _constants.SESSION_FETCHING,
        payload: {
          key: key,
          promise: promise
        }
      });
      return promise;
    };
  };
  this.sessionSetSearchId = function () {
    return function (dispatch, getState) {
      var key = 'session-set-search-id';
      var _getState7 = getState(),
        loading = _getState7.loading;
      if (loading.has(key)) return loading.get(key);
      var promise = _this.api.get("".concat((0, _api.selectedQuestionBankUrl)(getState()), "/search_init")).then(function (response) {
        return dispatch({
          type: _constants.SESSION_SET_SEARCH_ID,
          payload: {
            key: key,
            searchId: response.data.search_id
          }
        });
      });
      dispatch({
        type: _constants.SESSION_SEARCH_ID_FETCHING,
        payload: {
          key: key,
          promise: promise
        }
      });
      return promise;
    };
  };
  this.sessionRegister = function (firstName, lastName, email, password, deviceId) {
    var fetchAssociations = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
    var forceQuestionBankId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
    var isIframe = arguments.length > 7 ? arguments[7] : undefined;
    return function (dispatch, getState) {
      var key = 'session-register';
      var _getState8 = getState(),
        loading = _getState8.loading;
      if (loading.has(key)) return loading.get(key);
      var promise = _this.api.post('/register', {
        user: {
          first_name: firstName,
          last_name: lastName,
          email: email,
          password: password,
          device_id: deviceId
        }
      }).then(function (response) {
        dispatch(_this.sessionFetched(response, fetchAssociations, forceQuestionBankId, isIframe, key));
        return response;
      }).catch(function (error) {
        dispatch(_this.sessionReset(key));
        throw error;
      });
      dispatch({
        type: _constants.SESSION_FETCHING,
        payload: {
          key: key,
          promise: promise
        }
      });
      return promise;
    };
  };
  this.sessionSetCanSeeCorrectAnswers = function (enabled) {
    return function (dispatch, getState) {
      var _getState9 = getState(),
        users = _getState9.users,
        session = _getState9.session;
      var currentUser = users.get(session.get('current_user_id'));
      dispatch({
        type: _constants.SESSION_SET_CAN_SEE_CORRECT_ANSWERS,
        payload: {
          enabled: enabled && currentUser && currentUser.get('internal_role') === 'admin'
        }
      });
    };
  };
  this.api = api;
  this.config = config;
  this.notifications = notifications;
  this.performance = performance;
  this.questionBanks = questionBanks;
});
var _default = exports.default = Session;